<template>
  <div class="select-custom" :class="{ opened }" v-click-outside="close">
    <div class="value" @click="open">
      <span>{{ valueOrPlaceholder }}</span>
      <div class="badge bg primary round" v-if="showCount && selected.length">{{ selected.length }}</div>
    </div>
    <div class="select-custom__list" :class="{ opened }">
      <div v-for="(item, i) in options"
           :key="item.id">
        <NewCheckbox
            :model-value="selected"
            :label="item[labelBy]"
            :value="item.value"
            @set="setSelected"
        />
        <div v-if="i % separator && i + 1 !== options.length " class="separator"></div>
      </div>
    </div>
  </div>
</template>

<script>
import Checkbox from '@/components/form/Checkbox'
import outsize from '@/mixins/outsize'
import NewCheckbox from "@/components/NewCheckbox";

export default {
  name: 'NewSelect',
  components: {NewCheckbox, Checkbox},
  mixins: [outsize],
  model: {
    event: 'input',
    prop: 'value',
  },
  props: {
    name: String,
    separator: Number,
    options: Array,
    displaySelected: Boolean,
    placeholder: String,
    isMultiple: {
      type: Boolean,
      default: true,
    },
    showCount: {
      type: Boolean,
      default: true,
    },
    labelBy: {
      type: String,
      default: 'title'
    }
  },
  data() {
    return {
      opened: false,
      selected: [],
    }
  },
  methods: {
    open() {
      this.opened = !this.opened
    },
    close() {
      this.opened = false
    },
    setSelected(v) {
      if(this.selected.find(item => item === v)) {
        this.selected = []
      } else {
        this.selected = []
        this.selected.push(v)
      }
      this.$emit('input', this.selected)
    }
  },
  computed: {
    valueOrPlaceholder() {
      if (this.displaySelected && this.selected && this.selected.length) {
        const activeId = parseInt(this.selected[0])
        return this.options.find((x) => x.id === activeId)[this.labelBy]
      }

      return this.placeholder
    },
  }
}
</script>

<style lang="scss">
.select-custom {
  position: relative;
  background: #fff;
  width: 160px;

  .separator {
    border: 1px solid #F2F2F2;
    margin-top: 15px;
  }

  &__list {
    display: none;
    gap: 18px;
    padding: 53px 15px 25px;
    background: #fff;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: 10;
    border-radius: 5px;
    box-shadow: 0px 12px 21px rgba(204, 215, 230, 0.19);
    max-height: 517px;
    overflow-y: auto;

    .item {
      display: flex;
      align-items: center;
      cursor: pointer;
      margin-bottom: 0;

      .checkbox {
        width: 15px;
        height: 15px;
        margin-right: 8px;

        .v {
          border: 1px solid $dark;
          border-radius: 3px;
        }

        input:checked + .v {
          border: 1px solid $main;
        }
      }

      span {
        font-weight: 700;
        font-size: 12px;
        color: $darkGrey;
      }
    }

    &.opened {
      display: grid;
    }
  }

  .badge {
    z-index: 9;
    min-width: 0;
    margin-left: 7px;
  }

  .value {
    display: flex;
    align-items: center;
    height: 35px;
    background: url('~@/assets/icons/chevron-down.svg') no-repeat 94% center #fff;
    padding: 0 10px;
    font-weight: 700;
    font-size: 12px;
    line-height: 147.5%;
    border: 1px solid #f2f2f2;
    border-radius: 5px;
    cursor: pointer;
    user-select: none;
    position: relative;
    z-index: 11;
  }

  &.opened {
    .value {
      border: 1px solid transparent;
      background: url('~@/assets/icons/chevron-up.svg') no-repeat 94% center #fff;
    }
  }

  @include mobile {
    &.mobile-list {
      .value {
        font-size: 15px;
        border: none;
        background: none;
      }

      .select-custom__list {
        display: grid;
        gap: 24px;
        position: relative;
        padding: 18px 10px 25px;
        box-shadow: none;
        max-height: inherit;

        .item {
          .checkbox {
            width: 20px;
            height: 20px;
          }

          span {
            font-size: 14px;
          }
        }
      }
    }
  }
}
</style>
